import * as React from 'react';

import { ITripInfo } from '../../../repositories/dailyrent/entities/response/TripInfo';
import * as styles from './TripInfoBanner.css';

export interface ITripInfoBannerProps {
  tripInfo: ITripInfo;
}

/**
 * Компонент для отображения информации о поездке в модалке создания отзыва
 * Показывает фото объекта, название, даты и адрес
 */
export const TripInfoBanner: React.FC<ITripInfoBannerProps> = ({ tripInfo }) => {
  return (
    <div className={styles['container']}>
      {tripInfo.photoUrl && (
        <div className={styles['photo-container']}>
          <img src={tripInfo.photoUrl} alt={tripInfo.title} className={styles['photo']} />
        </div>
      )}
      <div className={styles['info']}>
        <h3 className={styles['title']}>{tripInfo.title}</h3>
        {tripInfo.dates && <div className={styles['dates']}>{tripInfo.dates}</div>}
        <div className={styles['address']}>{tripInfo.address}</div>
      </div>
    </div>
  );
};
